<template>

    <div class="flex justify-end">

        <a @click="showModal = true" v-show="show"
           class="cursor-pointer bg-green-dark text-white rounded py-2 px-4 inline-block">
            <i class="fa" :class="{'fa-lock': isPrivate, 'fa-users': isPublic}"></i> {{ visibility }}
        </a>

        <portal to="modals" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">Visibility</template>

                <ul class="list-reset">

                    <li :class="{'bg-grey-lighter': isPrivate}" class="">
                        <a class="p-4 flex cursor-pointer hover:bg-grey-light" @click="updateChart('private')">
                            <div class="flex items-center mr-4">
                                <i class="fa"
                                   :class="{'fa-check-circle-o': isPrivate, 'fa-circle-o': !isPrivate}"></i>
                            </div>
                            <div>
                                <h3><i class="fa fa-lock mr-2"></i> Private</h3>
                                <div class="mt-2">
                                    Only you can see and edit this board.
                                </div>
                            </div>
                        </a>
                    </li>

                    <li :class="{'bg-grey-lighter': isPublic}" class="">
                        <a class="p-4 flex cursor-pointer hover:bg-grey-light" @click="updateChart('public')">
                            <div class="flex items-center mr-4">
                                <i class="fa"
                                   :class="{'fa-check-circle-o': isPublic, 'fa-circle-o': !isPublic}"></i>
                            </div>
                            <div>
                                <h3><i class="fa fa-users mr-2"></i> Public</h3>
                                <div class="mt-2">
                                    Anyone with the link can see this board.<br>
                                    Only you can edit.
                                </div>
                            </div>
                        </a>
                    </li>

                </ul>
            </modal>
        </portal>
    </div>

</template>

<script>
    export default {
        name: "Visibility",

        data() {
            return {
                showModal: false,
            }
        },

        computed: {
            isPrivate() {
                return this.visibility === 'private';
            },
            isPublic() {
                return this.visibility === 'public';
            },
            loading() {
                return this.$store.state.loading;
            },
            show() {
                return !this.loading && this.visibility !== undefined && this.visibility.length > 0;
            },
            visibility() {
                return this.$store.state.rawData.visibility;
            }
        },
        methods: {
            updateChart(visibility) {
                this.$store.dispatch('updateVisibility', {
                    visibility: visibility,
                });
            }
        }
    }
</script>
